module.exports = __webpack_public_path__ + "static/media/CN.44454803.png";